import { conditionMessages } from './condition-messages.js'
import { enumOptionsPt } from './enum-options.js'
import { sectionCatalogPt } from './section-catalog.js'

export const pt = {
  visualGameStudio: {
    brand: 'Visual Game Studio',
    localizationUnsupported: 'Esta versão histórica não contém dados compilados completos e não pode ser localizada. Selecione outra versão.',
    seal: 'VG',
    viewport: {
      title: 'Use uma tela maior',
      body: 'Visual Game Studio é uma ferramenta desktop. Use uma tela com pelo menos 1024px de largura para editar packs.',
    },
    nav: { projects: 'Projetos', editor: 'Editor', assets: 'Assets', versions: 'Versões', turnVideos: 'Vídeos de turno', runChain: 'Cadeia da partida', localization: 'Idiomas', help: 'Ajuda', settings: 'Config.' },
    auth: { title: 'Entrar no Studio', subtitle: 'Use sua conta para gerenciar roteiros, assets, versões e publicação.', email: 'Email', password: 'Senha', login: 'Entrar', logout: 'Sair', loggingIn: 'Entrando', failed: 'Falha ao entrar' },
    topbar: { preview: 'Prévia', publish: 'Publicar', noProject: 'Nenhum projeto', account: 'Conta', themeLight: 'Tema claro', themeDark: 'Tema escuro' },
    projects: {
      title: 'Meus projetos',
      subtitle: 'Gerencie rascunhos visual-game, publicação e visibilidade.',
      tags: 'Tags', bulkTags: 'Tags em lote', bulkTagsPlaceholder: 'Fantasia, Romance, Mistério', applyToFiltered: 'Aplicar a {count} filtrados', bulkTagsApplied: 'Tags atualizadas em {count} roteiros',
      newProject: 'Novo projeto',
      search: 'Buscar projetos',
      filterAll: 'Todos',
      filterDraft: 'Rascunho',
      filterPublished: 'Publicado',
      sortUpdated: 'Atualizados',
      sortEpisode: 'Ordem dos níveis',
      levelNumber: 'Nível {number}',
      emptyTitle: 'Ainda não há projetos',
      emptyBody: 'Crie o primeiro pack e entre na edição estruturada.',
      edit: 'Editar',
      duplicate: 'Duplicar',
      rename: 'Renomear',
      visibility: 'Visibilidade',
      delete: 'Arquivar/Excluir',
      createTitle: 'Novo projeto',
      editTitle: 'Editar projeto',
      projectTitle: 'Título',
      seriesId: 'ID da série',
      seriesIdPlaceholder: 'ex.: painted_skin',
      seriesTitle: 'Título da série',
      scriptTitle: 'Título da história',
      seriesTitlePlaceholder: 'ex.: Painted Skin',
      episodeNo: 'Número do nível',
      episodeNoPlaceholder: '1',
      seriesHint: 'Deixe os três campos vazios para um nível independente. Para uma série, preencha todos e use um número único.',
      newSeries: 'Nova história',
      createSeries: 'Criar história',
      createSeriesTitle: 'Nova história',
      createSeriesHint: 'Criar a história também cria o primeiro nível. Depois, abra a história para adicionar mais níveis.',
      firstLevelTitle: 'Título do primeiro nível',
      firstLevelTitlePlaceholder: 'ex.: Entrar no templo',
      seriesCreated: 'História e primeiro nível criados',
      seriesSection: 'Histórias',
      standaloneSection: 'Níveis independentes',
      manageLevels: 'Gerenciar níveis',
      levelCount: '{count} níveis',
      newLevel: 'Novo nível',
      newStandalone: 'Novo nível independente',
      backToSeries: 'Voltar às histórias',
      seriesLevelsSubtitle: 'Gerencie em ordem os {count} níveis desta história.',
      belongsToSeries: 'História',
      searchLevels: 'Buscar níveis desta história',
      searchStandalone: 'Buscar níveis independentes',
      noMatchingLevels: 'Nenhum nível correspondente',
      locale: 'Idioma',
      associateLevel: 'Vincular nível existente',
      associateLevelTitle: 'Vincular nível independente',
      associateLevelHint: 'Move o nível independente original para {series} sem criar uma cópia ou alterar o conteúdo.',
      standaloneLevel: 'Nível independente',
      selectStandaloneLevel: 'Selecione um nível independente',
      levelAssociated: 'Nível vinculado à história',
      associateLevelFailed: 'Falha ao vincular o nível',
      private: 'Privado',
      public: 'Público',
      unlisted: 'Não listado',
      save: 'Salvar',
      cancel: 'Cancelar',
      creating: 'Criando',
      saving: 'Salvando',
      loading: 'Carregando projetos',
      loadFailed: 'Falha ao carregar projetos',
      createFailed: 'Falha ao criar',
      updateFailed: 'Falha ao salvar',
      duplicateFailed: 'Falha ao duplicar',
      deleteFailed: 'Falha ao excluir',
      created: 'Projeto criado',
      updated: 'Projeto salvo',
      duplicated: 'Projeto duplicado',
      archived: 'Projeto arquivado',
      deleted: 'Projeto excluído',
      confirmDelete: 'Confirme a ação. Packs publicados ou com dados de usuário serão arquivados; rascunhos sem uso serão excluídos permanentemente.',
      confirmTextLabel: 'Digite {title} para confirmar',
      scenes: 'Cenas',
      endings: 'Finais',
      updatedAt: 'Atualizado',
    },
    status: { draft: 'DRAFT', published: 'PUBLISHED', archived: 'ARCHIVED', unknown: 'UNKNOWN' },
    enumOptions: enumOptionsPt,
    sectionGroups: { basic: 'Base', state: 'Stats e estado', world: 'Mundo', cast: 'Elenco e objetos', info: 'Informação', gameplay: 'Jogabilidade', ending: 'Finais', assets: 'Assets' },
    editor: {
      title: 'Editor de roteiro',
      subtitle: 'Mantenha mapas, elenco, missões, regras, finais e mídia por seção.',
      section: 'Seção',
      readonly: 'Você não tem permissão para editar este projeto',
      unsaved: 'Alterações não salvas',
      saved: 'Salvo',
      save: 'Salvar',
      revert: 'Reverter',
      savedToast: 'Seção salva',
      saveFailed: 'Falha ao salvar',
      discardConfirm: 'Há alterações não salvas. Descartar?',
      discardTitle: 'Descartar alterações não salvas',
      discardBody: 'Esta seção tem alterações não salvas. Ao sair agora, elas não serão gravadas no banco.',
      stayEditing: 'Continuar editando',
      discardCta: 'Descartar alterações',
      deleteEntityTitle: 'Remover item',
      deleteEntityBody: 'Este item será removido da seção atual e gravado no banco após salvar.',
      deleteEntityBlocked: 'Este item é referenciado em {count} lugares. Remova as referências antes de excluir.',
      deleteEntityConfirmLabel: 'Digite {label} para confirmar a exclusão.',
      deleteEntityCta: 'Remover item',
      recentChanges: 'Alterações recentes',
      recentChangesHint: 'Mostra registros de auditoria do banco para este rascunho.',
      auditLoading: 'Carregando alterações',
      auditLoadFailed: 'Falha ao carregar alterações',
      noRecentChanges: 'Ainda não há alterações',
      auditActions: { section_update: 'Section salva', asset_upload: 'Asset enviado', asset_delete: 'Asset removido', compile: 'Compilado', publish: 'Publicado', rollback: 'Rollback' },
      focusedCheck: 'Checagem focada',
      structuredTab: 'Estruturado',
      jsonTab: 'JSON',
      jsonHelp: 'Alteracoes em JSON sincronizam com o formulario quando validas.',
      jsonInvalid: 'JSON invalido',
      addRow: 'Adicionar',
      searchOptions: 'Search options',
      dragRow: 'Arraste para reordenar',
      duplicateRow: 'Duplicar',
      removeRow: 'Remover',
      emptyRows: 'Sem linhas',
      item: 'Item',
      noId: 'Sem ID',
      sections: {
        mapLocations: 'Locais',
        mapGraph: 'Grafo de locais',
        npcs: 'NPCs',
        objects: 'Objetos',
        clues: 'Pistas',
        conclusions: 'Conclusões',
        infoBlocks: 'Blocos de info',
        sceneEvents: 'Eventos',
        actionRules: 'Regras de ação',
        endings: 'Finais',
        stateRegistry: 'Registro de estado',
        players: 'Personagens',
        quests: 'Missões',
        mediaTags: 'Tags de mídia',
        videoReferences: 'Referências para geração de vídeo',
        stageRules: 'Regras de cena',
        audioRules: 'Regras de áudio',
        voiceSettings: 'Configuração de vozes',
        voiceSettingsHelp: 'Defina primeiro as vozes padrão; cada idioma pode sobrescrevê-las em runtime, e campos vazios herdam o padrão.',
        audioMoodRules: 'Regras de BGM',
        statSfxRules: 'SFX de atributos',
        stateCgRules: 'Regras de CG por estado',
        followupRules: 'CG posteriores',
      },
      stateWorkspace: {
        initialTitle: 'Valores iniciais',
        initialBody: 'Ao criar uma nova run, estes valores são gravados nela: flags globais, estado de NPC, progresso de missões, estado de objetos e inventário inicial.',
        registryTitle: 'Registro de estado',
        registryBody: 'É a ficha de referência das keys de estado. Explica o que cada key significa, quem escreve, quem lê e qual história ou regra ela afeta.',
        relationshipTitle: 'Relação',
        relationshipBody: 'Valores iniciais definem o que é verdadeiro no início. O registro explica o significado de cada key. O registro não substitui os valores iniciais; ajuda em checagens, referências de regras e manutenção.',
        openingValues: 'Valores iniciais',
        registeredKeys: 'Keys registradas',
        initialHint: 'Mantenha só os valores que precisam existir no início. Estado NPC ou objeto aninhado aparece como path com ponto para alinhar com o registro.',
        registryHint: 'Registre toda key lida por regras de ação, condições, KP ou agentes. Fontes e impacto claros facilitam depuração depois.',
        registryTableTitle: 'Entradas do registro',
        unregisteredInitialKeys: 'Estas keys iniciais ainda não têm nota no registro:',
        keyPurpose: 'Uso',
        noRegistryNote: 'Uso não registrado',
        noRegistryHint: 'Adicione uma key igual no registro de estado abaixo para mostrar aqui seu significado e impacto runtime.',
      },
      sceneWorkspace: {
        scenesGroup: 'Cenas',
        emptyScenes: 'Ainda não há cenas. Adicione locais em Mapa primeiro.',
        noScene: 'Crie uma cena em Mapa primeiro.',
        noDescription: 'Esta cena ainda não tem descrição.',
        unlocked: 'Desbloqueada no início',
        locked: 'Bloqueada',
        sceneObjects: 'Definições de objetos da cena',
        sceneClues: 'Pistas da cena',
        sceneInfoBlocks: 'Blocos de info da cena',
        sceneEvents: 'Eventos da cena',
        sceneActionRules: 'Regras da cena',
        npcNote: 'Escolha os NPCs globais que aparecem nesta cena e edite o estado inicial deles nesta cena. Perfis completos ficam em NPC global.',
        objectNote: 'Edite objetos globais montados nesta cena. Definições salvam em objects global; posicionamento em map.locations[].objectIds.',
        clueNote: 'Esta visão filtra pistas globais para a cena atual. Novas pistas são atribuídas automaticamente a esta cena.',
        infoNote: 'Esta visão filtra blocos de info pelos NPCs desta cena.',
        eventNote: 'Esta visão filtra eventos pela cena atual. Ao salvar, locationId recebe esta cena.',
        ruleNote: 'Esta visão filtra regras de ação pela cena atual. Novas regras recebem condição location para não virarem globais.',
        tabs: {
          overview: 'Resumo',
          basic: 'Base',
          connections: 'Conexões',
          npcs: 'NPCs',
          objects: 'Objetos',
          clues: 'Pistas',
          infoBlocks: 'Info',
          sceneEvents: 'Eventos',
          actionRules: 'Regras',
        },
        hints: {
          basic: 'Nome, descrição, tipo e mídia da cena.',
          connections: 'Conexões de movimento desta cena para outras cenas.',
          npcs: 'NPCs presentes nesta cena e seus estados iniciais.',
          objects: 'Objetos globais montados nesta cena, com definições editáveis.',
          clues: 'Pistas ligadas à cena, seus NPCs ou objetos.',
          infoBlocks: 'Informações reveláveis e fatos ocultos dos NPCs da cena.',
          sceneEvents: 'Eventos de entrada, descoberta ou customizados desta cena.',
          actionRules: 'Regras ligadas a alvo desta cena ou condição location.',
        },
      },
      mediaUsage: {
        title: 'Media usage',
        subtitle: 'Shows where each media asset is bound in the game flow. Saving writes these bindings into structured tables used by the game runtime.',
        missingAsset: 'This tag is missing from the asset manifest',
        opening: 'Home opening CG',
        endingBook: 'Ending book background',
        entryStage: 'Entry stage',
        entryStageIdle: 'Entry idle video',
        defaultStage: 'Default stage',
        defaultStageIdle: 'Default idle video',
        revealedStage: 'Revealed stage',
        revealedStageIdle: 'Revealed idle video',
        defaultBgm: 'Default BGM',
        editInMedia: 'Edit in Media global rules',
        editInMediaStageRules: 'Edit in Media stage rules',
        editInMediaAudioRules: 'Edit in Media audio rules',
        editInMediaStateCgs: 'Edit in Media state CG rules',
        editInMediaFollowups: 'Edit in Media follow-ups',
        editInMap: 'Edit in Map location media',
        editInNpcs: 'Edit in NPC media tag',
        editInPlayers: 'Edit in Player character portrait',
        editInEndings: 'Edit in Ending CG',
      },
      sectionCatalog: sectionCatalogPt,
      fieldGroups: {
        public: 'Camada pública',
        secret: 'Camada secreta',
        secretBadge: 'Segredo · oculto do jogador',
      },
      fields: {
        id: 'ID',
        name: 'Nome',
        type: 'Tipo',
        state: 'Estado',
        label: 'Rótulo',
        scope: 'Escopo',
        source: 'Fonte',
        detail: 'Detalhe',
        summary: 'Resumo',
        prerequisiteConclusions: 'Conclusões prévias',
        relatedClues: 'Pistas relacionadas',
        content: 'Conteúdo',
        priority: 'Prioridade',
        target: 'Alvo',
        targetType: 'Tipo de alvo',
        mode: 'Modo',
        intent: 'Intenção',
        claim: 'Afirmação',
        claims: 'Afirmações semânticas',
        mediaTag: 'Media tag',
        referenceAssets: 'Reference assets',
        stageMediaTags: 'Stage portraits',
        phaseKey: 'Stage',
        tag: 'Tag',
        file: 'Arquivo',
        objectKey: 'Object key',
        mime: 'MIME',
        width: 'Largura',
        height: 'Altura',
        packId: 'Pack ID',
        title: 'Título',
        tagline: 'Resumo curto',
        assetManifestId: 'Asset manifest ID',
        videoSceneReferenceTag: 'Imagem de referência da cena',
        videoNpcReferenceTag: 'Imagem de referência do NPC',
        videoPlayerReferenceTag: 'Imagem de referência do jogador',
        coverTag: 'Capa horizontal (alternativa)',
        portrait_cover_tag: 'Capa vertical (9:16)',
        opening: 'Texto inicial',
        seoTitle: 'Título de lista',
        seoDescription: 'Resumo de lista',
        initialLocation: 'Local inicial',
        none: 'Nenhum',
        initialPhase: 'Fase inicial',
        turnLimit: 'Limite de turnos',
        openingStrategy: 'Estratégia inicial',
        defaultActionMode: 'Modo de ação padrão',
        statsDefinitions: 'Definições de stats',
        statId: 'ID',
        statName: 'Nome',
        statColor: 'Cor',
        initialValue: 'Inicial',
        description: 'Descrição',
        statRules: 'Regras de stats',
        initialStates: 'Estados iniciais',
        stateKey: 'Chave de estado',
        stateValue: 'Valor de estado',
        initialFlags: 'Flags iniciais',
        initialNpcStates: 'Estados NPC iniciais',
        initialQuestStates: 'Estados de missão iniciais',
        initialSceneEventStates: 'Eventos iniciais',
        initialObjectStates: 'Objetos iniciais',
        initialInventory: 'Inventário inicial',
        primaryNpcId: 'NPC principal',
        keeperRole: 'Papel KP',
        dynamicStoryEnabled: 'Ativar história dinâmica',
        singleScene: 'Modo de cena única',
        minDistinctTurns: 'Mínimo de turnos distintos',
        maxActiveBranches: 'Máximo de ramos ativos',
        maxGeneratedEndings: 'Finais gerados por partida',
        trackerExpiry: 'Turnos até expirar o fio',
        dynamicStoryPrinciples: 'Princípios da história dinâmica',
        dynamicStoryForbidden: 'Restrições da história dinâmica',
        referenceEndings: 'Finais de referência',
        referenceEndingsHint: 'Os exemplos são enviados apenas ao criador de ramos, não aos prompts normais de KP ou NPC.',
        referenceEnding: 'Final de referência',
        requiredConsequences: 'Consequências obrigatórias',
        phaseRules: 'Regras de fase',
        phase: 'Fase',
        principles: 'Princípios',
        forbidden: 'Regras proibidas',
        hiddenFacts: 'Fatos ocultos',
        displayName: 'Nome exibido',
        publicProfile: 'Perfil público',
        trueProfile: 'Perfil real',
        coverRole: 'Papel de disfarce',
        coverStory: 'História de disfarce',
        coverAttitude: 'Atitude de disfarce',
        species: 'Espécie',
        origin: 'Origem',
        hunger: 'Desejo',
        limitation: 'Limitação',
        danger: 'Perigo',
        appearance: 'Aparência',
        publicKnowledge: 'Conhecimento público',
        privateKnowledge: 'Conhecimento privado',
        disclosePolicy: 'Política de revelação',
        boundaries: 'Limites',
        mustDo: 'Deve fazer',
        mustNotDo: 'Não deve fazer',
        usable: 'Usável',
        damaged: 'Danificado',
        known: 'Conhecido',
        importance: 'Importância',
        ownerNpc: 'NPC dono',
        startsUnlocked: 'Liberado no início',
        unlockWhen: 'Condição de desbloqueio',
        speakableAs: 'Falas',
        locationId: 'ID do local',
        once: 'Uma vez',
        triggerWhen: 'Condição de gatilho',
        whenCondition: 'Condição de match',
        requires: 'Requisitos',
        invalidReason: 'Razão inválida',
        overrideKp: 'Sobrescrever KP',
        stopProcessing: 'Parar processamento',
        targetsAll: 'Todos os alvos',
        effectsStats: 'Mudanças de stats',
        effectsFlags: 'Flags a definir',
        effectsEvidence: 'Evidências a adicionar',
        locationChange: 'Mover para local',
        unlockLocations: 'Desbloquear locais',
        lockLocations: 'Bloquear locais',
        addInventory: 'Adicionar inventário',
        removeInventory: 'Remover inventário',
        sceneNarration: 'Narração da cena',
        visibleFindings: 'Descobertas visíveis',
        discoveredObjects: 'Objetos descobertos',
        npcReaction: 'Política de reação NPC',
        npcDirectiveNpc: 'NPC da diretriz',
        npcDirectiveTactic: 'Tática NPC',
        npcDirectiveMood: 'Humor NPC',
        mustReactTo: 'Deve reagir a',
        mustHide: 'Deve esconder',
        possibleEnding: 'Final imediato',
        reason: 'Razão',
        valueType: 'Tipo de valor',
        hardState: 'Estado duro',
        writers: 'Escritores',
        readers: 'Leitores',
        runtimeEffect: 'Efeito em runtime',
        notes: 'Notas',
        npcIds: 'NPC IDs',
        objectIds: 'Object IDs',
        sceneEventIds: 'Event IDs',
        connections: 'Conexões',
        to: 'Para',
        locked: 'Bloqueado',
        lockedReason: 'Razão de bloqueio',
        defaultCharacterId: 'Personagem padrão',
        showInSelection: 'Mostrar na seleção de personagem',
        gender: 'Gênero',
        age: 'Idade',
        archetype: 'Arquétipo',
        portraitTag: 'Mídia do retrato',
        attributes: 'Atributos',
        skills: 'Skills',
        inventory: 'Inventário',
        history: 'Histórico',
        traits: 'Traços',
        mainQuestId: 'Missão principal',
        statusAtStart: 'Estado inicial',
        steps: 'Passos',
        completeWhen: 'Condição de conclusão',
        failWhen: 'Condição de falha',
        entryTag: 'Entry tag',
        entryIdleTag: 'Entry idle tag',
        defaultTag: 'Default tag',
        defaultIdleTag: 'Default idle tag',
        revealedTag: 'Revealed tag',
        revealedIdleTag: 'Revealed idle tag',
        openingTag: 'Opening CG tag',
        endingBookTag: 'Ending book tag',
        idleTag: 'Idle video tag',
        mood: 'Mood',
        statKey: 'Stat key',
        triggerType: 'Trigger type',
        statePath: 'State path',
        threshold: 'Threshold',
        oncePerRun: 'Once per run',
        triggerScope: 'Trigger scope',
        sortOrder: 'Sort order',
        defaultBgmTag: 'Default BGM tag',
        defaultBgmMood: 'Default BGM mood',
        voiceRole: 'Papel',
        defaultVoice: 'Voz padrão',
        inheritDefaultVoice: 'Herdar padrão',
        playerVoiceId: 'Voz do jogador',
        npcVoiceId: 'Voz do NPC',
        endingVoiceId: 'Voz do final',
      },
    },
    conditions: conditionMessages.pt,
    assets: {
      title: 'Assets',
      subtitle: 'Gerencie retratos, CG, áudio e referências.',
      file: 'Arquivo',
      search: 'Buscar tag, MIME ou object key',
      upload: 'Enviar asset',
      uploading: 'Enviando',
      uploaded: 'Asset enviado',
      uploadFailed: 'Falha ao enviar',
      generateImage: 'Gerar imagem',
      generatingImage: 'Gerando imagem',
      imageGenerated: 'Imagem gerada e salva como asset',
      imageGenerationFailed: 'Falha ao gerar imagem',
      image_purpose: 'Uso da imagem',
      image_purpose_asset: 'Recurso geral',
      image_purpose_portrait_cover: 'Capa vertical',
      portrait_cover_hint: 'Gera uma capa 9:16 (1080 × 1920). Depois, selecione-a como capa vertical nas configurações do roteiro.',
      imagePrompt: 'Descrição da imagem',
      imagePromptHint: 'O Seedream gerará uma imagem 2K e a salvará neste pacote.',
      deleted: 'Asset removido',
      delete: 'Remover asset',
      deleteFailed: 'Falha ao remover',
      openFile: 'Abrir arquivo',
      inspect: 'Inspecionar',
      inspector: 'Inspetor de asset',
      selectAsset: 'Selecione um asset para ver prévia, metadados e referências.',
      noPreview: 'Sem prévia',
      noMetadata: 'Sem metadados',
      loading: 'Carregando assets',
      loadFailed: 'Falha ao carregar assets',
      emptyTitle: 'Envie o primeiro retrato ou CG',
      empty: 'Nenhum asset ainda',
      duplicateTag: 'Este tag já existe. Use um tag único.',
      referenceCount: '{count} referências',
      references: 'Referências',
      noReferences: 'Nenhuma seção referencia este asset.',
      confirmDeleteTitle: 'Remover asset',
      confirmDeleteBody: 'Este asset será removido do rascunho atual.',
      confirmReferencedDeleteBody: 'Este asset tem {count} referências. Elas quebrarão após a remoção.',
      confirmTextLabel: 'Digite {tag} para confirmar',
      confirmDeleteCta: 'Remover asset',
      coverage: {
        total: 'Total de assets',
        referenced: 'Usados na história',
        unreferenced: 'Sem uso',
        unreferencedTags: 'Tags sem uso',
        none: 'Todos os assets são referenciados por campos da história.',
      },
      filters: { all: 'Todos' },
      groups: { cg: 'CG e cutscenes', character: 'Personagens e retratos', scene: 'Cenas e referências', audio: 'Música e SFX', ui: 'Assets de UI', reference: 'Imagens de referência', other: 'Outros arquivos' },
      types: { image: 'Imagem', video: 'Vídeo', audio: 'Áudio', asset: 'Arquivo' },
      meta: { type: 'Tipo', mime: 'MIME', dimensions: 'Dimensões', objectKey: 'Object key', hash: 'Hash' },
    },
    versions: { title: 'Versões', subtitle: 'Compilar, validar, publicar, reverter e pré-visualizar.', compile: 'Compilar rascunho', compiling: 'Compilando', compileDone: 'Compilação concluída', compileFailed: 'Falha ao compilar', loadChecksFailed: 'Falha ao carregar checagens', publishDone: 'Versão publicada', publishFailed: 'Falha ao publicar', previewFailed: 'Falha ao autorizar a prévia', rollback: 'Rollback', rollbackDone: 'Rollback concluído', rollbackFailed: 'Falha no rollback', checks: 'Checagens de publicação', noChecks: 'A versão selecionada ainda não tem checagens. Compile o rascunho ou selecione uma versão.', version: 'Versão', emptyTitle: 'Ainda não há versões', empty: 'Ainda não há versões. Compile o rascunho primeiro.', publishBlocked: 'Corrija as checagens bloqueantes antes de publicar.', jumpToSection: 'Abrir section', snapshot: 'Snapshot de compilação', openSnapshot: 'Ver snapshot', closeSnapshot: 'Fechar snapshot', noSnapshot: 'Esta versão não tem snapshot de compilação para exibir.', checkStatus: { ok: 'Aprovado', warning: 'Aviso', error: 'Erro', empty: 'Sem checagens' }, checkSummary: { ok: 'Todas as checagens passaram.', warning: '{warnings} avisos precisam de revisão.', error: '{errors} checagens bloqueiam a publicação.', empty: 'Nenhuma checagem carregada.' }, confirm: { publishTitle: 'Publicar versão', publishBody: 'Após publicar, o app de jogador usará esta versão como live.', publishCta: 'Publicar', rollbackTitle: 'Reverter versão', rollbackBody: 'A reversão troca a versão live para a selecionada. Dados de jogadores existentes não são apagados.', rollbackAcknowledge: 'Entendo que isto troca a versão live e quero continuar.', rollbackCta: 'Reverter' } },
    localization: { title: 'Localização do conteúdo', description: 'Gere ou atualize cada idioma manualmente para a versão selecionada. Salvar o rascunho não inicia traduções.', externalNotice: 'Ao gerar, o texto da história é enviado ao modelo de tradução configurado e o resultado é salvo na tabela de traduções.', sourceSummary: 'Esta versão contém {count} textos traduzíveis.', loading: 'Carregando status…', loadFailed: 'Falha ao carregar o status da tradução', generate: 'Gerar', generateAll: 'Gerar todos os idiomas ({count})', generatingAll: 'Gerando todos os idiomas…', batchProgress: 'Processando idioma {current} de {total} · {completed} concluídos', generateAllDone: 'Traduções geradas para {count} idiomas', generateAllFailed: 'Tradução em lote concluída: {completed} com sucesso, {failed} com falha', allAlreadyDone: 'Todos os idiomas já estão concluídos', regenerate: 'Gerar novamente', generating: 'Gerando…', generateDone: 'Tradução gerada', generateFailed: 'Falha ao gerar tradução', progressStatus: { idle: 'Preparando', translating: 'Traduzindo', saving: 'Salvando', completed: 'Concluído', failed: 'Falha' }, status: { source: 'Idioma de origem', missing: 'Pendente', ready: 'Concluído' }, locales: { 'zh-CN': 'Chinês simplificado', en: 'Inglês', ja: 'Japonês', ko: 'Coreano', es: 'Espanhol', pt: 'Português' } },
    translationInventory: { title: 'Detalhes do conteúdo', all: 'Tudo', pending: 'Pendente', reused: 'Reutilizado', translated: 'Traduzido', source: 'Texto de origem', target: 'Tradução de destino', notTranslated: 'Ainda não traduzido', empty: 'Nenhum conteúdo corresponde ao filtro.', reuseFrom: 'O conteúdo sem alterações será reutilizado de {version}.', reusableCount: '{count} reutilizáveis', pendingCount: '{count} pendentes' },
    common: { retry: 'Tentar novamente', refresh: 'Atualizar', open: 'Abrir', close: 'Fechar', more: 'Mais', required: 'Obrigatório' },
  },
}
